import { render, staticRenderFns } from "./StudentScheduleLookup.vue?vue&type=template&id=513e5dac&"
import script from "./StudentScheduleLookup.vue?vue&type=script&lang=js&"
export * from "./StudentScheduleLookup.vue?vue&type=script&lang=js&"
import style0 from "./StudentScheduleLookup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCheckbox,VDivider,VSkeletonLoader,VTab,VTabItem,VTabs,VTabsItems})
